import { render, staticRenderFns } from "./SmsHistory.vue?vue&type=template&id=1ffc7f8b&scoped=true"
import script from "./SmsHistory.vue?vue&type=script&lang=js"
export * from "./SmsHistory.vue?vue&type=script&lang=js"
import style0 from "./SmsHistory.vue?vue&type=style&index=0&id=1ffc7f8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc7f8b",
  null
  
)

export default component.exports